// package: friendemic.api.response
// file: friendemic/api/response/types.proto
"use strict";

exports.ChannelTypeFriendly = {
  enumMap: {
		0: "CarFax",
		1: "CarGurus",
		2: "Cars.com",
		3: "DealerRater",
		4: "Facebook",
		5: "Google",
		6: "Yelp",
  },
  friendlyMap: {
		"CarFax": 0,
		"CarGurus": 1,
		"Cars.com": 2,
		"DealerRater": 3,
		"Facebook": 4,
		"Google": 5,
		"Yelp": 6,
  },
  toFriendly: function(e) {
    const v = this.enumMap[e]
    if (v === undefined) {
      throw new Error(e + ' is not a valid ChannelType enum option')
    }

    return v
  },
  toEnum: function(v) {
    const e = this.friendlyMap[v]
    if (e === undefined) {
      throw new Error('\'' + v + '\'' + ' is not a valid ChannelType friendly value')
    }

    return e
  }
}
